module.exports = __webpack_public_path__ + "static/media/goodnest_app6_preview.aa5209f7.jpg";